export default "__VITE_ASSET__Dt4_VXrj__"